import axios from 'axios';

export const retrieveWrkDclrDtl = async({ setReadWrkDclrList, wrkDclrList, setSelect, setSelectData, noneWrkDclr }: any) => {
  console.log(wrkDclrList)

  if (!noneWrkDclr) {
    setSelect(wrkDclrList[0].wrkInfo);
    setSelectData(wrkDclrList);
    setReadWrkDclrList([wrkDclrList[0].wrkDclrSeq]);
  };
}

export const retrieveDngrEvalDtl = async({ wrkDclrSeq, noneWrkDclr, setFldAgntDataList, setWrkrInfoDataList, setMainDtlData, setDngrEvalDataList, setApprMemo, sctrGb, evntSeq }: any) => {
  if (!noneWrkDclr) {
    let rtrnData = await axios.post('admin/api/dngrEval/retrieveDngrEvalDtlData', {wrkDclrSeq: wrkDclrSeq})
    const mainDtlData = rtrnData.data.mainDtlData;
    const siteUserDataList = rtrnData.data.siteUserDataList;
    const wrkrUserDataList = rtrnData.data.wrkrUserDataList;
    const dngrEvalDataList = rtrnData.data.dngrEvalDataList;
    let lastmemo = await axios.post('admin/api/dngrEval/retrieveWrkPrcsLastMemo', { wrkDclrSeq: wrkDclrSeq })
    setApprMemo(lastmemo.data);
    setFldAgntDataList(siteUserDataList);
    setWrkrInfoDataList(wrkrUserDataList);
    setMainDtlData(mainDtlData);
    setDngrEvalDataList(dngrEvalDataList);
  } else {
    // 위험성평가 데이터는 업종으로 가져오기
    // 작업신고서가 없는 경우 : 위험성 평가 -> 업종에 따른 기본 설정 내용 넣어주기
    let rtrnData = await axios.post('admin/api/dngrEval/retrieveDngrEvalDtlDataNoneWrkDclr', {sctrGb: sctrGb, evntSeq: evntSeq})
    const mainDtlData = rtrnData.data.mainDtlData;
    const dngrEvalDataList = rtrnData.data.dngrEvalDataList;
    setMainDtlData(mainDtlData);
    setDngrEvalDataList(dngrEvalDataList);
  }
}

export const retrieveAncmntDtl = async({sctrGb, setAncmntData, setAncmnt, setReadAncmntList, readAncmntList, setFileDataList}: any) => {
  let rtrnData = await axios.post('admin/api/tbm/retriveTbmBrdDataBySctrGbCd', { sctrGbCd: sctrGb })
  if(rtrnData.data.length > 0){
    setAncmntData(rtrnData.data);
    let atchFileId = rtrnData.data[0].atchFileId;
    setAncmnt(rtrnData.data[0]);
    setReadAncmntList(readAncmntList.concat(rtrnData.data[0].seq));
    rtrnData = await axios.post('admin/api/cmmn/fileInfoForTableView', {atchFileId:atchFileId});
    setFileDataList(rtrnData.data.fileList);
  }else{
    setAncmntData([]);
  }
}

export const retrieveSftyRulDtl = async(sctrGbCd:string, setSftyRulDtlData: any, setFileDataList: any, setReadSftyRulList: any, readSftyRulList: any, setSftyRulDataList:any) => {
  let rtrnData = await axios.post('admin/api/tbm/retrieveBrdDataBySctrGbCd', {sctrGbCd:sctrGbCd, boardGb:'003'});
  
  if(rtrnData.data.length > 0){
    setSftyRulDataList(rtrnData.data);
    let atchFileId = rtrnData.data[0].atchFileId;
    setSftyRulDtlData(rtrnData.data[0]);
    setReadSftyRulList(readSftyRulList.concat(rtrnData.data[0].seq));
    rtrnData = await axios.post('admin/api/cmmn/fileInfoForTableView', {atchFileId:atchFileId});
    setFileDataList(rtrnData.data.fileList);
  }else{
    setSftyRulDataList([]);
  }
}

export const retrieveSftyEduDtl = async(sctrGbCd:string, setSftyEduDtlData: any, setEduDataList: any, setReadSftyEduList: any, readSftyEduList:any) => {
  let rtrnData = await axios.post('admin/api/tbm/retrieveBrdDataBySctrGbCd', {sctrGbCd:sctrGbCd, boardGb:'002'});
  if(rtrnData.data.length > 0){
    setEduDataList(rtrnData.data);
    setSftyEduDtlData(rtrnData.data[0]);
    setReadSftyEduList(readSftyEduList.concat(rtrnData.data[0].seq));
  }else{
    setEduDataList([]);
  }
}

// 영상이 사실상 끝까지 재생됐는지 판정한다.
// 모바일/WebView 에서는 끝까지 재생돼도 ended 이벤트가 안 뜨는 경우가 있어,
// ended 뿐 아니라 종료 0.5초 이내(near-end)면 완료로 간주한다. (탐색 바가 없어 끝으로 점프 불가)
export const isPlayerEnded = (player: any) => {
  if (!player) return false;
  return player.ended || (player.duration > 0 && player.currentTime >= player.duration - 0.5);
}

export const updateSmrtTbmPrcsStat = async(user: any, smartTbmSeq: any, equipChk: any) => {
  const rsltCnt = await axios.post('admin/api/tbm/updateSmrtTbmPrcsStat', {userSeq: user.seq, auth: user.auth, userNm: user.name, userPhone: user.phone, smartTbmSeqStr:smartTbmSeq, equipChk:equipChk});
  return rsltCnt.data;
}

export const saveTmTbmData = async(fileRef: any, user: any, evntSeqStr: any, sctrGb: any, wrkDclrSeq: any) =>{
  const fileList = fileRef.current.files;
  const formData = new FormData();
  if(fileList.length > 0){
      formData.append('multipartFiles', fileList[0]);
  }
  const wrkDclrSeqStr = wrkDclrSeq.toString();
  const jsonObject = {userSeq:user.seq, rgstrSeq:user.seq, cmpnySeq:user.companySeq, evntSeqStr, sctrGb, wrkDclrSeqStr};
  formData.append('jsonData', JSON.stringify(jsonObject));
  const rsltCnt = await axios.post('admin/api/tbm/saveTmTbmData', formData);
  return rsltCnt.data;
}

export const tabOneMoveNext = ({ readWrkDclrList, wrkDclrList, dngrEvalRef, setFocus, setSnackbarTxt, noneWrkDclr, selectHandler }: any) => {
  if (!noneWrkDclr) {
    for(let i=0; i<wrkDclrList.length; i++){
      if(!readWrkDclrList.includes(wrkDclrList[i].wrkDclrSeq)){
        setSnackbarTxt(`${i+1}번째 위험성 평가서입니다.`);
        dngrEvalRef.current?.scrollIntoView({ behavior: 'smooth' });
        // 평가서 데이터 수정하기
        selectHandler(wrkDclrList[i]);
        setFocus(true);
        setTimeout(() => setFocus(false), 3000);
        return false;
      }}
  }
  return true;
}

export const tabTwoMoveNext = ({ readAncmntList, ancmntData, setSnackbarTxt }: any) => {
  if(ancmntData){
    for (let i = 0; i < ancmntData.length; i++) {
      if (!readAncmntList.includes(ancmntData[i].seq)) {
        setSnackbarTxt((i+1) + '번째 공지사항을 확인해 주십시오.');
        return false;
      }}
  }

  return true;
}

export const tabThreeMoveNext = ({ readSftyRulList, sftyRulDataList, setSnackbarTxt }: any) => {
  for(let i=0; i < sftyRulDataList.length; i++){
    if(!readSftyRulList.includes(sftyRulDataList[i].seq)){
      setSnackbarTxt((i+1) + '번째 안전수칙을 확인해 주십시오.');
      return false;
  }}
  return true;
}

export const tabFiveMoveNext = ({ readSftyEduList, eduDataList, setSnackbarTxt }: any) => {
  for(let i=0; i < eduDataList.length; i++){

    if(!readSftyEduList.includes(eduDataList[i].seq)){
      setSnackbarTxt((i+1) + '번째 안전교육을 확인해 주십시오.');
      return false;
  }}

  return true;
}
